export default __webpack_public_path__ + "images/my290-default-image.png";